module.exports = __webpack_public_path__ + "media/application/images/logo-white-background-84b6e1540dfdb5a35315d690acbf2a62.svg";